'use client';

import { useEffect } from 'react';

const DEVTOOLS_STYLE_ID = 'scarlet-sync-next-devtools-branding';

const DEVTOOLS_CSS = `
  [data-next-badge-root] {
    display: none !important;
    --color-outer-border: rgba(204, 0, 51, 0.58) !important;
    --color-inner-border: rgba(255, 255, 255, 0.34) !important;
    --color-hover-alpha-subtle: rgba(255, 255, 255, 0.18) !important;
    --focus-color: #cc0033 !important;
  }

  [data-next-badge] {
    background: rgba(204, 0, 51, 0.94) !important;
    box-shadow:
      0 0 0 1px rgba(204, 0, 51, 0.48),
      inset 0 0 0 1px rgba(255, 255, 255, 0.28),
      0 14px 28px -12px rgba(204, 0, 51, 0.46) !important;
  }

  [data-next-badge] [data-next-mark] {
    background: rgba(255, 255, 255, 0.08) !important;
  }

  [data-next-badge] [data-next-mark]:hover {
    background: rgba(255, 255, 255, 0.18) !important;
  }

  #next-logo svg path {
    stroke: white !important;
  }
`;

function brandPortal(portal: Element) {
  const root = portal.shadowRoot;
  if (!root || root.getElementById(DEVTOOLS_STYLE_ID)) return;

  const style = document.createElement('style');
  style.id = DEVTOOLS_STYLE_ID;
  style.textContent = DEVTOOLS_CSS;
  root.appendChild(style);
}

export default function DevToolsBranding() {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return;

    const brandExistingPortal = () => {
      document.querySelectorAll('nextjs-portal').forEach(brandPortal);
    };

    brandExistingPortal();
    const observer = new MutationObserver(brandExistingPortal);
    observer.observe(document.documentElement, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return null;
}
